import { Box, Grid, MenuItem, Paper, TextField, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { getAllProjects } from '../../../redux/features/courseSlice';
import dayjs from 'dayjs';
import GlobalDataGrid from '../../../components/mui/DataGrid/GlobalDatagrid';
import { deductionTable } from './utils/refundTableColumns';
import FromAndToDatePicker from '../../../components/mui/FromAndToDatePicker';
import GlobalSelectFieldWithoutFormikNew from '../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { getDeductionTableForEnrollment, getDeductionTableForNonEnrollment } from '../../../redux/features/refundSlice';
import RefundDeductionCountBoxes from './RefundDeductionCountBoxes';
import { NonEnroledDeductionTable } from './utils/NonEnroledDeductionTable';
import { typeOfStudent } from '../../../utils/constants/GlobalStaticData';


export default function RefundDeduction() {
  const { projects } = useSelector((state) => state.course);
  const {
    deductionTable: { data, meta },
    loading,
  } = useSelector((state) => state.refund);
  const [selectedType, setSelectedType] = useState(typeOfStudent[0]);
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const dispatch = useDispatch();

  const projectsData = [{ id: 0, name: 'All' }, ...projects];
  const [selectedProject, setSelectedProject] = useState(projectsData[0]);

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search } = paginationData;

  const dispatchParams = useMemo(() => {
    return {
      gridSize,
      pageNum,
      search,
      fromDate,
      toDate,
      project: selectedProject?.id ? selectedProject?.id : null,
    };
  }, [pageNum, gridSize, search, fromDate, toDate, selectedProject?.id]);

  useEffect(() => {
    if (selectedType?.id) {
      dispatch(getDeductionTableForNonEnrollment(dispatchParams));
    } else {
      dispatch(getDeductionTableForEnrollment(dispatchParams));
    }
  }, [selectedType,dispatchParams]);

  useEffect(() => {
    dispatch(getAllProjects());
  }, []);

  const columns = useMemo(() => {
    if (selectedType?.id) {
      return NonEnroledDeductionTable();
    } else {
      return deductionTable();
    }
  }, [selectedType]);
  return (
    <GlobalWrapper title={'Refund Deduction'}>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} md={6} lg={4}>
          <FromAndToDatePicker
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            fullWidth={true}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <GlobalSelectFieldWithoutFormikNew
            label={'Project'}
            data={projectsData}
            keys={{ itemId: 'id', itemValue: 'name' }}
            selectedDetails={selectedProject}
            setChange={setSelectedProject}
            fullWidth={true}
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <GlobalSelectFieldWithoutFormikNew
            keys={{ itemId: 'id', itemValue: 'name' }}
            data={typeOfStudent}
            label={'Student Type'}
            fullWidth={true}
            selectedDetails={selectedType}
            setChange={setSelectedType}
          />
        </Grid>
      </Grid>
      <Box mb={2}>
        <RefundDeductionCountBoxes loading={loading} datas={meta} isNonEnrollment={selectedType?.id} />
      </Box>

      <GlobalDataGrid
        loading={loading}
        tableHead={columns}
        meta={meta?.totalRecords || 0}
        rows={data}
        rowUniqueId="sl_no"
      />
    </GlobalWrapper>
  );
}
